import clientAPI from "./apiclient.config";
import qs from 'qs';
import { getConfig } from "../configStore";

/* const baseURL = window.location.protocol + '//' + window.location.host + env.VUE_APP_AUTHORIZATION_URL;
const baseOrchURL = window.location.protocol + '//' + window.location.host + env.VUE_APP_ORCH_API;
const baseQrCodeURL = window.location.protocol + '//' + window.location.host + env.VUE_APP_QR_CODE_AUTHORIZATION_URL;
 */
export default {
  abort() {
    const env = getConfig();
    const baseURL = window.location.protocol + '//' + window.location.host + env.VUE_APP_AUTHORIZATION_URL;

    return clientAPI().post(baseURL + '/cancel');
  },

  login(user) {
    const env = getConfig();
    const baseURL = window.location.protocol + '//' + window.location.host + env.VUE_APP_AUTHORIZATION_URL;

    console.log("auth.service login");

    let config = {
      headers: {
        'InfoCert-Correlation-ID': user.transactionId
      }
    }

    const data = {
      username: user.username,
      password: user.password,
      sessionId: user.transactionId,
      authCode: user.authCode,
      elapsed: user.elapsed
    }
    return clientAPI().post(baseURL, qs.stringify(data), config);
  },

  qrLogin(user) {
    const env = getConfig();
    const baseQrCodeURL = window.location.protocol + '//' + window.location.host + env.VUE_APP_QR_CODE_AUTHORIZATION_URL;

    console.log("auth.service qrLogin");
    let config = {
      headers: {
        'InfoCert-Correlation-ID': user.sessionId
      }
    }
    const data = {
      sessionId: user.sessionId,
      authCode: user.authCode
    }
    return clientAPI().post(baseQrCodeURL, qs.stringify(data), config);
  },

  getSPData(transactionId) {
    const env = getConfig();
    const baseURL = window.location.protocol + '//' + window.location.host + env.VUE_APP_AUTHORIZATION_URL;

    console.log("auth.service getSPData");
    let config = {
      headers: {
        'InfoCert-Correlation-ID': transactionId
      }
    }
    const url = baseURL + "/api/metadata?transactionId=" + transactionId;
    return clientAPI().get(url, config);
  },

  callback() {
    const env = getConfig();
    const baseURL = window.location.protocol + '//' + window.location.host + env.VUE_APP_AUTHORIZATION_URL;
    
    console.log("auth.service callback");
    const oauth2Url = baseURL + '/oauth2'
    return clientAPI(oauth2Url).get("/callback", {});
  },

  logout() {
    sessionStorage && sessionStorage.removeItem("user")
  },

  requestData(transactionId) {
    const env = getConfig();
    const baseOrchURL = window.location.protocol + '//' + window.location.host + env.VUE_APP_ORCH_API;
    
    console.log("auth.service requestData");

    let config = {
      headers: {
        'InfoCert-Correlation-ID': transactionId
      }
    }

    const url = baseOrchURL + "transaction/" + transactionId + "/request-data"

    console.log("auth.service url: " + url);

    let result = clientAPI().get(url, config);

    console.log("auth.service requestData result: " + result);

    return result;
  },


  startChallenge(passwordLessSessionId) {
    const env = getConfig();
    const url = window.location.protocol + '//' + window.location.host + `/passwordless/api/challenge`;
    console.log("auth.service startChallenge");
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    const body = {
        type: "newPasswordlessAuthenticationChallenge",
        passwordLessSessionId,
        challenge_type: "qrcode",
        tenant: "INFOCERT",
        service: "SPID",
        reason: "Login authentication"
    };
    return clientAPI().post(url, body, config);
  },

  verifyChallenge(challengeId) {
    const env = getConfig();
    const url = window.location.protocol + '//' + window.location.host + `/passwordless/api/challenge/${challengeId}/status`;
    console.log("auth.service verifyChallenge");
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return clientAPI().post(url, {}, config);
  },

  updateChallenge(challengeId, updateData) {
    const env = getConfig();
    const url = window.location.protocol + '//' + window.location.host + `/passwordless/api/challenge/${challengeId}`;
    console.log("auth.service updateChallenge");
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return clientAPI().put(url, updateData, config);
  },


};
